import { openLiveStream } from '../live-stream.ts'

/**
 * `/api/v1/communication/events` — o tempo real do inbox (F047, ADR-0030).
 *
 * `openCommunicationEventStream` abre o `EventSource` e devolve um jeito de
 * fechá-lo. Não faz `.parse()` aqui — quem chama decide o que fazer com cada
 * evento (tipicamente invalidar uma query do TanStack Query), e importar
 * `CommunicationStreamEventSchema` só para isto acoplaria este arquivo ao
 * formato exato de um jeito que um `try/catch` de JSON já resolve mais
 * simples.
 */

export type CommunicationStreamHandlers = {
  onEvent: (event: {
    type: string
    id?: string
    conversationId?: string
  }) => void
  onResync?: () => void
  /** A conexão abriu de verdade — o sinal que `useCommunicationRealtime` usa para desligar o fallback de polling. */
  onOpen?: () => void
  /**
   * O navegador desistiu de reconectar (`readyState === CLOSED`) — não um
   * erro isolado, que o `EventSource` já tenta sozinho superar. Só este
   * estado final é motivo para ligar o polling de fallback.
   */
  onClosed?: () => void
}

export const openCommunicationEventStream = (
  handlers: CommunicationStreamHandlers
): { close: () => void } =>
  // Reabre sozinha se cair ou emudecer (F212, `lib/live-stream.ts`).
  openLiveStream({
    url: '/api/v1/communication/events',
    onOpen: () => handlers.onOpen?.(),
    onClosed: () => handlers.onClosed?.(),
    onResync: () => handlers.onResync?.(),
    onMessage: (message) => {
      try {
        const data: unknown = JSON.parse(message.data)
        if (
          typeof data === 'object' &&
          data !== null &&
          'type' in data &&
          typeof data.type === 'string'
        ) {
          handlers.onEvent(
            data as { type: string; id?: string; conversationId?: string }
          )
        }
      } catch {
        // Um frame malformado não derruba o stream inteiro.
      }
    },
  })
